const REQUIRED_FIELDS = [
  "nombre",
  "telefono",
  "correo",
  "precio",
  "ubicacion",
  "lat",
  "lng",
  "tipo",
  "descripcion",
  "frente",
  "fondo",
  "metros",
  "nivel",
  "estacionamiento",
  "servicios",
  "disponibilidad",
  "tieneRestricciones",
  "negociosMismaPlaza",
];

const FIELD_LABELS = {
  nombre: "nombre",
  telefono: "telefono",
  correo: "correo",
  precio: "precio",
  ubicacion: "ubicacion",
  lat: "ubicacion exacta en mapa",
  lng: "ubicacion exacta en mapa",
  tipo: "tipo de propiedad",
  descripcion: "descripcion",
  frente: "frente",
  fondo: "fondo",
  metros: "metros cuadrados",
  altura: "altura",
  nivel: "nivel o piso",
  estacionamiento: "estacionamiento",
  servicios: "servicios",
  disponibilidad: "disponibilidad",
  tieneRestricciones: "restricciones del espacio",
  negociosMismaPlaza: "negocios en la misma plaza",
};

const normalize = (value) => (value || "").toString().trim();

export const reviewPropertySubmission = (form, media = {}) => {
  const alerts = [];
  const reminders = [];
  const blockers = [];
  let score = 0;

  const missingFields = REQUIRED_FIELDS.filter((field) => !normalize(form[field]));
  if (missingFields.length) {
    blockers.push(
      `Faltan campos obligatorios: ${missingFields
        .map((field) => FIELD_LABELS[field] || field)
        .join(", ")}`
    );
    score += 50;
  }

  if (form.tieneRestricciones === "si" && !normalize(form.restricciones)) {
    blockers.push("Indico que si hay restricciones, pero no explico cuales son");
    score += 25;
  }

  const cleanPhone = normalize(form.telefono).replace(/\D/g, "");
  if (cleanPhone.length !== 10) {
    blockers.push("Telefono con formato distinto a 10 digitos");
    score += 35;
  }

  if (/^(\d)\1+$/.test(cleanPhone) || cleanPhone === "1234567890") {
    blockers.push("Telefono con patron sospechoso");
    score += 45;
  }

  const price = Number(form.precio);
  if (!Number.isFinite(price) || price <= 0) {
    blockers.push("Precio invalido");
    score += 30;
  }

  if (normalize(form.descripcion).length < 40) {
    blockers.push("Descripcion muy corta");
    score += 20;
  }

  const imageCount = media.imageUrls?.length || 0;
  if (imageCount < 3) {
    blockers.push("Muy pocas fotos para publicar con buena calidad");
    score += 25;
  }

  if (!(media.videoUrls?.length > 0)) {
    reminders.push("Video pendiente para mejorar la publicacion");
  }

  if (!(media.planUrls?.length > 0)) {
    reminders.push("Croquis o plano pendiente, no bloquea la publicacion");
  }

  alerts.push(...blockers, ...reminders);

  const needsManualReview = blockers.length > 0;

  return {
    estadoPublicacion: needsManualReview ? "requiere_revision_manual" : "publicada",
    pagoEstado: form.plan === "gratis" ? "no_aplica" : "pendiente",
    score,
    alerts,
    blockers,
    reminders,
    needsManualReview,
    adminNote: needsManualReview
      ? `Requiere revision manual: ${blockers.join("; ")}`
      : reminders.length
      ? `Publicada automaticamente. Recordatorios: ${reminders.join("; ")}`
      : "Publicada automaticamente sin alertas.",
  };
};
